<h2 mat-dialog-title>Foto verwijderen</h2>
<mat-dialog-content>
    <p>Weet je zeker dat je deze foto wilt verwijderen?</p>
    <p *ngIf="data.filename">Bestand: <strong>{{ data.filename }}</strong></p>
    <p><em>Deze actie kan niet ongedaan worden gemaakt.</em></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()">Annuleren</button>
  <button mat-raised-button color="warn" (click)="onDeleteClick()">Verwijderen</button>
</mat-dialog-actions>
